define('flight-with-jquery',['require','es5-shim','es5-sham','jquery','flight/lib/index'],function (require) {
    require("es5-shim");
    require("es5-sham");
    window.$ = require("jquery");
    return require("flight/lib/index");
});

